import { BookmarkedSingleRecording, SingleRecording } from '../types/recording';

export function isBookmarkedRecording(recording: SingleRecording): recording is BookmarkedSingleRecording {
  return recording.bookmark !== undefined;
}
